import { authService } from "../../utils/authService";
import { logger } from "../../services/logger.service";
import { store } from "../../store";
import { clearTokens, setIsError } from "../../store/slices/authSlice";
import { refusalFor } from "./accessRefusal";

interface HttpResponse {
  status: number;
  /** The server's body. Its `code` is what says which refusal a 403 is (H6). */
  data?: unknown;
}

export function errorHandler<T extends HttpResponse>(response: T): T {
  const islogin = authService.isLoggedIn();

  const status = response.status;

  if (islogin && status === 401) {
    logger.warn("Unauthorized access - logging out user", {
      component: "ErrorHandler",
      status: 401,
      correlationId: logger.getCorrelationId(),
    });

    store.dispatch(clearTokens());
    authService.logout().catch((error) => {
      logger.error("Logout failed after 401 error", error, {
        component: "ErrorHandler",
        status: 401,
        correlationId: logger.getCorrelationId(),
      });
    });
  } else if (islogin && status === 403) {
    // A refusal of this one action, not a broken session: the code travels so
    // the dialog can say what was refused, and nobody is signed out for it.
    const code =
      (typeof response.data === "object" && response.data !== null
        ? (response.data as { code?: string }).code
        : undefined) || "FORBIDDEN";
    const refusal = refusalFor(code);

    logger.error("Forbidden access - refused", undefined, {
      component: "ErrorHandler",
      status: 403,
      code,
      correlationId: logger.getCorrelationId(),
    });

    store.dispatch(
      setIsError({
        isError: true,
        message: refusal?.message ?? "Unauthorised access",
        code,
      }),
    );
  } else {
    store.dispatch(setIsError(false));
  }

  return response;
}
